const getUserList = state => state.userList;


export default {
  getUserList,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js